import HeroSection from './components/HeroSection';
import HotGrid from './components/HotGrid';
import ReviewSection from './components/ReviewSection';
import DailySection from './components/DailySection';
import CTASection from './components/CTASection';

export default function Home() {
  const seoData = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        name: '911爆料网',
        url: 'http://baoliaogua.cn/',
        description:
          '911爆料网是国内领先的娱乐资讯与爆料追踪平台，专注于网红黑料、明星塌房、每日吃瓜资讯的实时追踪与深度报道。',
        foundingDate: '2020',
        contactPoint: {
          '@type': 'ContactPoint',
          email: 'hello@baoliaogua.cn',
          contactType: 'customer service',
        },
      },
      {
        '@type': 'WebSite',
        name: '911爆料网',
        url: 'http://baoliaogua.cn/',
        description:
          '911爆料网官网实时覆盖网红黑料、明星塌房现场与每日吃瓜爆料事件，第一时间追踪网络热门爆点。',
        potentialAction: {
          '@type': 'SearchAction',
          target: {
            '@type': 'EntryPoint',
            urlTemplate: 'http://baoliaogua.cn/search?q={search_term_string}',
          },
          'query-input': 'required name=search_term_string',
        },
      },
      {
        '@type': 'WebPage',
        name: '911爆料网官网 - 网红黑料明星塌房每日吃瓜爆料追踪',
        description:
          '911爆料网官网实时覆盖网红黑料、明星塌房现场与每日吃瓜爆料事件，第一时间追踪网络热门爆点，不延迟不掉线。',
        url: 'http://baoliaogua.cn/',
        isPartOf: {
          '@type': 'WebSite',
          name: '911爆料网',
          url: 'http://baoliaogua.cn/',
        },
      },
      {
        '@type': 'FAQPage',
        mainEntity: [
          {
            '@type': 'Question',
            name: '911爆料网是什么？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '911爆料网是国内领先的娱乐资讯与爆料追踪平台，专注于网红黑料、明星塌房、每日吃瓜资讯的实时追踪与深度报道。',
            },
          },
          {
            '@type': 'Question',
            name: '911爆料网更新频率如何？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '911爆料网每天7×24小时不间断追踪全网热点，每日更新数十条最新爆料内容，确保您不错过任何一个大瓜。',
            },
          },
          {
            '@type': 'Question',
            name: '如何向911爆料网提供爆料线索？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '您可以通过发送邮件至tips@baoliaogua.cn提交爆料线索，我们的编辑团队会第一时间审核处理。',
            },
          },
        ],
      },
    ],
  };

  return (
    <>
      <title>
        911爆料网官网-911爆料网入口 | 网红黑料明星塌房每日吃瓜爆料追踪
      </title>
      <meta
        name="description"
        content="911爆料网官网实时覆盖网红黑料、明星塌房现场与每日吃瓜爆料事件，第一时间追踪网络热门爆点，不延迟不掉线。911爆料网、911吃瓜爆料网、网红黑料、吃瓜爆料、每日爆料。"
      />
      <meta
        name="keywords"
        content="911爆料网,911爆料网站,911爆料,911吃瓜爆料,911吃瓜爆料网,911爆料吃瓜,911黑料爆料,网红黑料,吃瓜爆料,每日爆料"
      />
      <link rel="canonical" href="http://baoliaogua.cn/" />
      <meta
        property="og:title"
        content="911爆料网官网-911爆料网入口 | 网红黑料明星塌房每日吃瓜爆料追踪"
      />
      <meta
        property="og:description"
        content="911爆料网官网实时覆盖网红黑料、明星塌房现场与每日吃瓜爆料事件，第一时间追踪网络热门爆点。"
      />
      <meta property="og:url" content="http://baoliaogua.cn/" />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="911爆料网" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta
        name="twitter:title"
        content="911爆料网官网-911爆料网入口 | 网红黑料明星塌房每日吃瓜爆料追踪"
      />
      <meta
        name="twitter:description"
        content="911爆料网官网实时覆盖网红黑料、明星塌房现场与每日吃瓜爆料事件，第一时间追踪网络热门爆点。"
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(seoData) }}
      />

      <main>
        <HeroSection />
        <HotGrid />
        <ReviewSection />
        <DailySection />
        <CTASection />
      </main>
    </>
  );
}